import { useTranslation } from '@wix/wix-i18n-config';

export type ResolveBabelSeo = (
  key: string,
  params?: Record<string, string>,
) => string;

export const useBabelSeo = (): ResolveBabelSeo => {
  const { t } = useTranslation();

  return (key, params) => {
    const resolved = t(key, params);
    if (!resolved || resolved === key) {
      return '';
    }
    return resolved;
  };
};
